export const assetBrandConstants = {
  API_INSERT: '/api/brand/insert',
  API_UPDATE: '/api/brand/update',
  API_DELETE: '/api/brand/delete',
  API_GET: '/api/brand/',
  API_GETALL: '/api/brand/getall',

  INSERT_REQUEST: 'ASSET_BRAND_INSERT_REQUEST',
  INSERT_SUCCESS: 'ASSET_BRAND_INSERT_SUCCESS',
  INSERT_FAILURE: 'ASSET_BRAND_INSERT_FAILURE',

  UPDATE_REQUEST: 'ASSET_BRAND_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ASSET_BRAND_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ASSET_BRAND_UPDATE_FAILURE',

  DELETE_REQUEST: 'ASSET_BRAND_DELETE_REQUEST',
  DELETE_SUCCESS: 'ASSET_BRAND_DELETE_SUCCESS',
  DELETE_FAILURE: 'ASSET_BRAND_DELETE_FAILURE',

  GET_REQUEST: 'ASSET_BRAND_GET_REQUEST',
  GET_SUCCESS: 'ASSET_BRAND_GET_SUCCESS',
  GET_FAILURE: 'ASSET_BRAND_GET_FAILURE',

  GETALL_REQUEST: 'ASSET_BRAND_GETALL_REQUEST',
  GETALL_SUCCESS: 'ASSET_BRAND_GETALL_SUCCESS',
  GETALL_FAILURE: 'ASSET_BRAND_GETALL_FAILURE',

  RESET: 'ASSET_BRAND_RESET',
  SERVICE: 'ASSET_BRAND_SERVICE',
};
